import { render, staticRenderFns } from "./RegisterContact.vue?vue&type=template&id=606766a6"
import script from "./RegisterContact.vue?vue&type=script&lang=js"
export * from "./RegisterContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports